export var LOAD_VERSIONS_REQUEST = 'app/Versions/LOAD_VERSIONS_REQUEST';
export var LOAD_VERSIONS_SUCCESS = 'app/Versions/LOAD_VERSIONS_SUCCESS';
export var LOAD_VERSIONS_FAILURE = 'app/Versions/LOAD_VERSIONS_FAILURE';
export var LOAD_USERS_REQUEST = 'app/Versions/LOAD_USERS_REQUEST';
export var LOAD_USERS_SUCCESS = 'app/Versions/LOAD_USERS_SUCCESS';
export var LOAD_USERS_FAILURE = 'app/Versions/LOAD_USERS_FAILURE';
export var VERSIONS_QUERY = 'app/Versions/VERSIONS_QUERY';
